/**
 * Class to implement the move-up functionality
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class MoveUp {
    private static instance: MoveUp;

    public static readonly selector = `scope="move-up"`;

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.buttons.forEach((button) => this.handle(button));
    }

    /**
     * Method to instantiate all
     * buttons on the current page
     *
     * @returns {MoveUp}
     */
    public static use(): MoveUp {
        if (!MoveUp.instance) {
            MoveUp.instance = new MoveUp();
        }
        return MoveUp.instance;
    }

    /**
     * Selects the buttons
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get buttons(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[${MoveUp.selector}]`);
    }

    /**
     * Handles the action on the button
     *
     * @param {HTMLElement} button
     * @returns {void}
     */
    protected handle(button: HTMLElement): void {
        button.addEventListener("click", () => {
            // For Safari
            document.body.scrollTop = 0;

            // For Chrome, Firefox, IE and Opera
            document.documentElement.scrollTop = 0;
        });
    }
}
